import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {
  COLORS,
  TYPOGRAPHY,
  UTILITIES,
} from 'compositions/constants/constants';
import Icon from './IconExample';

const StyledCTA = styled.a`
  cursor: pointer;
  display: block;
  font-weight: ${TYPOGRAPHY.fontWeightHeavy};
  ${props =>
    props.type === 'primary' &&
    css`
      background-color: ${COLORS.secondary};
      border-radius: ${UTILITIES.borderRadius};
      border: 1px solid ${COLORS.secondary};
      color: ${COLORS.white};
      display: inline-block;
      font-family: ${TYPOGRAPHY.fontFamilyHeadings};
      padding: 10px 19px;
      position: relative;
      text-align: center;
      text-decoration: none;
      vertical-align: middle;

      &:hover {
        color: ${COLORS.white};
        text-decoration: none;
        background-color: ${COLORS.secondaryHover};
      }

      &:visited {
        color: ${COLORS.white};
      }

      &:focus {
        border-color: ${COLORS.secondary};
        color: ${COLORS.white};
        background-color: ${COLORS.secondary};
      }
    `}
  ${props =>
    props.type === 'secondary' &&
    css`
      color: ${COLORS.secondary};
      display: block;
      position: relative;
      text-decoration: none;

      &:hover {
        color: ${COLORS.secondary};
        text-decoration: underline;
      }

      &:before {
        content: '';
        display: block;
        height: 16px;
        left: 0;
        margin-top: -8px;
        position: absolute;
        top: 50%;
        width: 16px;
      }

      &:visited {
        color: ${COLORS.secondaryHover};
      }
    `}

  ${props =>
    props.type === 'link' &&
    css`
      color: ${COLORS.primary};
      text-decoration: none;
      display: inline-block;

      &:hover {
        color: ${COLORS.primaryHover};
        text-decoration: underline;
      }

      &:active,
      &:focus,
      &:visited {
        color: ${COLORS.primary};
      }
    `}

  
  ${props => css([props.css])}
`;

const CTA = props => {
  const hasIcon = props.type === 'secondary' && <Icon name="chevronRight" />;
  return (
    <StyledCTA {...props}>
      {hasIcon}
      {props.children}
    </StyledCTA>
  );
};

CTA.propTypes = {
  /** Type of CTA   */
  type: PropTypes.string.isRequired,
  /** URL, used when `Link` is rendered as an `<a />` */
  href: PropTypes.string.isRequired,
  /** Specifies where to open the navigated document */
  target: PropTypes.string.isRequired,
  /** Link content (accepted via string or components / DOM nodes) */
  children: PropTypes.node,
};

CTA.defaultProps = {
  type: 'primary',
  target: '_self',
  href: '#',
};

export default CTA;
